(function () {
  const changeBtnPosition = (sectionId) => {
    if (window.innerWidth < 750) {
      document
        .querySelectorAll(`#${sectionId} .swiper-button`)
        .forEach((button) => {
          button.style.display = 'none';
        });
      return;
    }

    const imageEl = document.querySelector(
      `#${sectionId} .fbc-image-wrapper`
    );

    if (imageEl) {
      document
        .querySelectorAll(`#${sectionId} .swiper-button`)
        .forEach((button) => {
          button.style.display = 'block';
          button.style.top = imageEl.offsetHeight / 2 - 15 + 'px';
        });
    }
  };

  const initFeaturedBlogCarousel = () => {
    document
      .querySelectorAll('.section-featured-blog-carousel')
      .forEach((section) => {
        const sectionId = section.id;
        if (!sectionId) return;

        const swiperEl = section.querySelector('.fbc-swiper');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }

        const navNext = section.querySelector('.swiper-button-next');
        const navPrev = section.querySelector('.swiper-button-prev');
        let navConfig = {};

        if (navNext && navPrev) {
          navConfig = {
            navigation: {
              nextEl: `#${sectionId} .swiper-button-next`,
              prevEl: `#${sectionId} .swiper-button-prev`,
            },
          };
        }

        new Swiper(swiperEl, {
          speed: 800,
          keyboard: true,
          slidesPerView: 'auto',
          spaceBetween: 0,
          grabCursor: true,
          watchOverflow: true,
          ...navConfig,
        });

        changeBtnPosition(sectionId);
      });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initFeaturedBlogCarousel();

    window.addEventListener('resize', function () {
      document
        .querySelectorAll('.section-featured-blog-carousel')
        .forEach((section) => {
          if (section.id) changeBtnPosition(section.id);
        });
    });

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('section-featured-blog-carousel')) {
        initFeaturedBlogCarousel();
      }
    });
  });
})();
